import { Tooltip, TooltipProps } from "@mantine/core";

interface Props extends Omit<TooltipProps, "events">{}

export function HoverAndTouchTooltip(props: Props){
	return <Tooltip events={{ hover: true, touch: true, focus: false }} {...props} />
}